// extracted by mini-css-extract-plugin
export default {"userMenu":"CustomToggle_userMenu__utgGw","open":"CustomToggle_open__4NygK"};